"use client";
import { jsx } from "react/jsx-runtime";
import { useCriteo } from "../../../../utils/criteo/CriteoProvider.js";
import { useState, useEffect } from "react";
import { useTracking } from "react-tracking";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { getVideoBeacons, getVideoInformation, getCarouselA11yInformation } from "./VideoSpotlight/utils.js";
import { VideoSpotlightDefault } from "./VideoSpotlight/view.default.js";
import { VideoSpotlightRail } from "./VideoSpotlight/view.rail.js";
import { VideoSpotlightSkeleton } from "./VideoSpotlight/view.skeleton.js";
import { COMPONENT_NAME } from "./constants.js";
import { useCriteoAnalytics } from "./utils.js";
function CriteoVideoSpotlight({
  contentStackEntry = {},
  locale,
  products,
  placement,
  ParentSKUs,
  productTileSx,
  sx = {},
  variant = "default",
  isPdp = false
}) {
  const { isDesktop } = useCheckScreen();
  const { productTileConfigData } = useCriteo();
  const [isLoading, setIsLoading] = useState(true);
  const [videoBeacons, setVideoBeacons] = useState({});
  const analytics = useCriteoAnalytics({ placement, products });
  const { trackEvent } = useTracking();
  const [videoInformation, setVideoInformation] = useState({
    legalText: "",
    options: {}
  });
  useEffect(() => {
    (placement == null ? void 0 : placement.TagVideoVAST) && getVideoBeacons(placement == null ? void 0 : placement.TagVideoVAST, trackEvent).then((objVAST) => {
      setVideoInformation(
        getVideoInformation({
          objVAST,
          isDesktop,
          locale,
          placement,
          trackEvent,
          variant
        })
      );
      setVideoBeacons(objVAST);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }, [placement, trackEvent, isDesktop, locale, variant]);
  if (!products || !placement) return null;
  const { criteo_placement_name } = (contentStackEntry == null ? void 0 : contentStackEntry.third_party_curation) || {};
  const carouselA11yInformation = getCarouselA11yInformation(locale);
  if (isLoading) {
    return /* @__PURE__ */ jsx(VideoSpotlightSkeleton, { variant });
  }
  if (videoBeacons && videoInformation && variant === "rail") {
    return /* @__PURE__ */ jsx(
      VideoSpotlightRail,
      {
        ParentSKUs,
        analytics,
        carouselA11yInformation,
        contentStackEntry,
        locale,
        productTileConfigData,
        productTileSx,
        sx,
        testId: `${COMPONENT_NAME}_${criteo_placement_name}_${variant}`,
        videoBeacons,
        videoInformation,
        isCriteo: true
      }
    );
  } else if (videoBeacons && videoInformation && variant === "default") {
    return /* @__PURE__ */ jsx(
      VideoSpotlightDefault,
      {
        ParentSKUs,
        analytics,
        carouselA11yInformation,
        contentStackEntry,
        locale,
        productTileConfigData,
        productTileSx,
        sx,
        testId: `${COMPONENT_NAME}_${criteo_placement_name}_${variant}`,
        videoBeacons,
        videoInformation,
        isPdp,
        isCriteo: true
      }
    );
  } else {
    return null;
  }
}
CriteoVideoSpotlight.displayName = COMPONENT_NAME;
export {
  CriteoVideoSpotlight
};
